// extracted by mini-css-extract-plugin
export var activityContainer = "_nt-0";
export var typingIndicatorContainer = "_nt-1";
export var typingIndicatorDot = "_nt-2";
export var wave = "_nt-3";